import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const RepresentativeClients = (props) => {
	const representativeClients = props.data.representative_clients;

	if (!_.isArray(representativeClients) || _.isEmpty(representativeClients)) {
		return null;
	}

	return (
		<ul className="bio-list">
			{_.map(representativeClients, ({ rc_name: name }) => (
				<li className="bio-list__item" key={_.uniqueId('list-item-')}>
					{name}
				</li>
			))}
		</ul>
	);
};

RepresentativeClients.propTypes = {
	data: PropTypes.object.isRequired,
};

export default RepresentativeClients;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/representative-clients.js